import isNil from 'lodash/isNil';

import { store } from '@store';

import { AbstractField } from './AbstractField';

export class CustomComputedField extends AbstractField<string, string> {
    public get hasData(): boolean {
        return this.isChanged || (!isNil(this.fieldValue) && this.fieldValue !== '');
    }

    public makeUpdateParams(): string {
        return this.fieldValue;
    }

    protected get isChanged(): boolean {
        return !!store.entry.changedComputedFields.get(this.fieldName);
    }

    protected setFieldValue(value: string): void {
        this.fieldValue = value;
    }
}
